import React, { useEffect, useState } from "react";
import Wrapper from "./RoutingSchedule.styled";
import backarrow from "../../../images/backarrow.svg";
import Heading from "../../../Components/Headings/MainHeading/Heading";
import { Button } from "../../../Components/Styled/Style";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Icon } from "@iconify/react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlinePlusCircle } from "react-icons/ai";
import ShiftModal from "./ShiftModal";
import { useDispatch, useSelector } from "react-redux";
import {
  createShiftsInCity,
  getShiftsInCity,
  setError,
  updateShiftsInCity,
} from "../../../Store/Reducers/Settings/actions";
import DaySchedule from "../../../Components/Settings/OperatingLocations/RoutingLocations/DaySchedule";
import { Modal } from "antd";
import { ToastTopRight } from "../../../Components/Toasts/top-right";

function RoutingSchedule(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { shifts, error } = useSelector((state) => state.Delivery);
  const [modal, setModal] = useState(false);
  const [active_date, setActiveDate] = useState(new Date());

  const [shift_date, setShiftDate] = useState(
    moment(new Date()).format("YYYY-M-d")
  );
  useEffect(() => {
    getShifts();
  }, []);

  const getShifts = () => {
    dispatch(getShiftsInCity());
  };

  const createShift = () => {
    dispatch(
      createShiftsInCity({
        start_datetime: moment(shift_date)
          .add(0, "hours")
          .format("YYYY-MM-D HH:MM:ss"),
        end_datetime: moment(shift_date)
          .add(2, "hours")
          .format("YYYY-MM-D HH:MM:ss"),
        desired_carriers: 1,
      })
    );
  };
  const updateShift = (payload) => {
    dispatch(updateShiftsInCity(payload));
  };

  const filteredShiftsByDate = () => {};

  const show14Days = () => {
    var daysOfYear = [];
    for (
      var d = new Date();
      d <= moment().add(13, "days");
      d.setDate(d.getDate() + 1)
    ) {
      daysOfYear.push(new Date(d));
    }

    return daysOfYear.map((x, index) => {
      return (
        <div
          className={`wrap center ${
            moment(active_date).format("D") === moment(x).format("D") &&
            "active"
          }`}
          onClick={() => setActiveDate(x)}
        >
          <p className="day_name">{moment(x).format("ll").substring(0, 3)}</p>
          <p className="day_number">{moment(x).format("D")}</p>
        </div>
      );
    });
  };

  const weekDaysSchedule = () => {
    var days = [];
    for (
      var d = new Date();
      d <= moment().add(13, "days");
      d.setDate(d.getDate() + 1)
    ) {
      const day = moment(d).format("D");
      days.push({
        full_date: moment(d).format(),
        name: moment(d).format("LLLL").split(",")[0] + " " + day,
        number: day,
        shifts: getFilteredShifts(day),
      });
    }
    return days.map((x, index) => {
      return (
        <DaySchedule
          day={x}
          modal={modal}
          setModal={setModal}
          setActiveDate={setActiveDate}
          setShiftDate={setShiftDate}
        />
      );
    });
  };

  const getFilteredShifts = (day_number) => {
    return shifts.filter((item) => {
      if (moment(item.end_datetime).format("D") === day_number) {
        // active day validation is missing   && moment(active_date).day
        return item;
      }
    });
  };

  useEffect(() => {
    getFilteredShifts();
  }, []);

  useEffect(() => {
    if (error != "") {
      ToastTopRight.fire({
        icon: "error",
        title: error.msg,
      });
    }
  }, [error]);

  return (
    <Wrapper>
      {/* <Modal
        visible={error != ""}
        centered
        closable={true}
        footer={false}
        onCancel={() => dispatch(setError(false))}
        onHide={() => dispatch(setError(false))}
        className="modal-width-420 modal-title-center"
      >
        <pre>{JSON.stringify(error, 0, 2)}</pre>
      </Modal> */}
      <div className="header d-flex justify-content-between">
        <div className="heading d-flex justify-content-start">
          <img
            src={backarrow}
            alt="arrow"
            className="back-arrow"
            onClick={() => navigate("/settings")}
          />
          <Heading text="Delivery Timeframes" />
        </div>
        <div className="buttons d-flex justify-content-between">
          <Button className="delete">Cancel Route </Button>
          <Button className="cancel">Re-Route current</Button>
          <Button className="save">Dispatch current</Button>
        </div>
      </div>

      <div className="schedule bg-white">
        <div className="d-flex justify-content-between">
          <Heading
            text={`${moment().format("MMMM")} ${moment().format(
              "D"
            )}th - ${moment().add(13, "days").format("D")}th`}
          />
          <p className="caption">Showing 2 weeks from today</p>
        </div>
        <div className="d-flex justify-content-between border-bottom days mt-2">
          {show14Days()}
        </div>
        <div className="d-flex-wrap justify-content-between">
          {weekDaysSchedule()}
        </div>
      </div>

      <ShiftModal
        modal={modal}
        setModal={setModal}
        date={shift_date}
        setDate={setShiftDate}
        getFilteredShifts={(day_number) => getFilteredShifts(day_number)}
        createShift={createShift}
        updateShift={updateShift}
        allShifts={shifts}
      />
    </Wrapper>
  );
}

export default RoutingSchedule;
